import { Component, Vue, Watch } from 'vue-property-decorator'
// @ts-ignore
import pdf from '@teckel/vue-pdf'
import _ from 'lodash'

@Component({
  components: {
    pdf,
  },
})
export default class PdfViewer extends Vue {
  /* eslint-disable */
  public pdfFile: any
  public pdfPages: any[]
  public pdfDocumentLoadingTask: any | null = null
  public pdfLoadingError: any | null = null
  /* eslint-enable */

  public blobUri: string
  // public currentPage: number

  public constructor() {
    super()
    this.pdfFile = null
    this.pdfPages = []

    this.blobUri = ''
    // this.currentPage = 0
  }

  public get countPages(): number {
    return this.pdfFile ? this.pdfFile.numPages : 0
  }

  public  get currentPage() {
    return this.$store.getters.currentPage || 1;
  }

  @Watch('blobUri', { immediate: true })
  public async onBlobUriChanged(): Promise<void> {
    if (this.blobUri) {
      const loadingTask = pdf.createLoadingTask(this.blobUri)
      loadingTask.promise.then(async (result: any) => {
        this.pdfFile = result
        await this.onPdfFileChanged()
      }).catch(async (ex: any) => {
        this.pdfLoadingError = ex
        this.pdfFile = null
        await this.onPdfFileChanged()
      })
      this.pdfDocumentLoadingTask = loadingTask
    } else {
      this.pdfFile = null
      this.pdfDocumentLoadingTask = null
    }
  }

  @Watch('pdfFile', { immediate: true })
  public async onPdfFileChanged(): Promise<void> {
    if (this.pdfFile) await this.loadPdfPages()
    else this.pdfPages = []
  }

  private async loadPdfPages(): Promise<void> {
    this.pdfPages = await Promise.all(_.map(_.range(1, this.countPages + 1), async (page) => {
      return await this.pdfFile.getPage(page)
    }))
  }

  @Watch('countPages', { immediate: true })
  public onCountPagesChnaged(): void {
    this.$store.dispatch('setCurrentPage', 0)
  }

  // eslint-disable-next-line
  public getPdfPageContainer(page: number): any {
    // eslint-disable-next-line
    return _.first(this.$refs['pdfPage__' + page] as any[])
  }

  public goToNextPage(): void {
    if (this.currentPage < this.countPages) this.goToPage(this.currentPage + 1)
  }

  public goToPreviousPage(): void {
    if (this.currentPage > 1) this.goToPage(this.currentPage - 1)
  }

  public goToPage(page: number): void {
    if (page > 0 && page <= this.countPages) {
      // eslint-disable-next-line
      this.getPdfPageContainer(page)?.scrollIntoView({ behavior: 'auto'})
      this.$store.dispatch('setCurrentPage', page)
    }
  }

  public onPdfPageVisibilityChanged(isVisible: boolean, entry: IntersectionObserverEntry): void {
    if (isVisible) this.$store.dispatch('setCurrentPage', +entry.target.id.split('__')[1])
    let el = document.getElementById('pageScroller') as HTMLElement
    if (el) {
      el.scrollLeft = (this.currentPage - 1) * 35
    }
  }
}
